export default __webpack_public_path__ + "static/media/Vacanted_LOGO_header.6c7b2f06.png";